export default {
  width: 17,
  height: 17,
  svg: `
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.35827 12.7165C9.86985 12.7165 12.7165 9.86985 12.7165 6.35827C12.7165 2.8467 9.86985 0 6.35827 0C2.8467 0 0 2.8467 0 6.35827C0 9.86985 2.8467 12.7165 6.35827 12.7165ZM6.35828 11.0202C8.93343 11.0202 11.021 8.93262 11.021 6.35746C11.021 3.7823 8.93343 1.69472 6.35828 1.69472C3.78312 1.69472 1.69554 3.7823 1.69554 6.35746C1.69554 8.93262 3.78312 11.0202 6.35828 11.0202Z"/>
<path d="M11.4375 10.0879L15.3722 14.0225C15.7446 14.395 15.7446 14.9989 15.3722 15.3713C14.9997 15.7438 14.3958 15.7438 14.0234 15.3713L10.0887 11.4367L11.4375 10.0879Z"/>
`
}
